import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-solid-svg-icons/faXmark";
import { Button } from "@wondermaps/ui";

interface ConsentBannerProps {
  onAccept: () => void;
  onDismiss: () => void;
  onShown?: () => void;
}

export function ConsentBanner({ onAccept, onDismiss, onShown }: ConsentBannerProps) {
  const { t } = useTranslation("common");
  useEffect(() => {
    onShown?.();
    // Mount-only: each banner mount = one prompt opportunity.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div
      data-testid="consent-banner"
      className="fixed inset-x-0 z-40 bg-background/95 backdrop-blur-sm border-t"
      style={{
        bottom: "var(--bottom-nav-height, 0px)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      <div className="max-w-lg mx-auto px-4 py-3 flex items-center justify-between gap-3">
        <p className="text-sm text-muted-foreground">
          {t("consent.analyticsNotice")}{" "}
          <a href="https://www.wondermaps.co/privacy" target="_blank" rel="noopener noreferrer" className="underline hover:text-foreground">
            {t("learnMore")}
          </a>
        </p>
        <div className="flex items-center gap-1 shrink-0">
          <Button onClick={onAccept} className="min-h-[44px]">
            {t("accept")}
          </Button>
          <Button
            variant="ghost"
            onClick={onDismiss}
            className="min-h-[44px] min-w-[44px] px-2"
            aria-label={t("dismiss", { defaultValue: "Dismiss" })}
          >
            <FontAwesomeIcon icon={faXmark} className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
